import { FortuneTeller, Menu, Tag, ChatRoom, User, Category } from ".";
import { MenuTypeV2, Review } from "../types";

export default class TelFortune extends Menu {
  type: MenuTypeV2;
  id: number;
  title: string;
  costPerMinute: number;
  imageUrl: string;
  averageScore: number;
  fortuneTeller?: FortuneTeller;
  isFavorited?: boolean;
  isSetNotify?: boolean;
  isBlocked?: boolean;
  isPublished?: boolean;
  salesQuantity?: number;
  averageCallDuration?: number;
  averageDeliveryDuration?: number;
  content?: string;
  note?: string;
  sampleChatRoom?: ChatRoom;
  divinationTags?: Tag[];
  sceneTags?: Tag[];
  telFortuneReviews?: Review[];
  purchasedUsers?: User[];
  category?: Category;
  sceneTagIds?: number[];
  divinationTagIds?: number[];

  constructor(data?: Partial<TelFortune>) {
    super(data);
    Object.assign(this, data);

    if (!data) return;

    this.fortuneTeller = data.fortuneTeller
      ? new FortuneTeller(data.fortuneTeller)
      : null;
    this.divinationTags =
      data?.divinationTags?.map((tag: any) => new Tag(tag)) ?? [];
    this.sceneTags = data?.sceneTags?.map((tag: any) => new Tag(tag)) ?? [];
    this.sampleChatRoom = data.sampleChatRoom
      ? new ChatRoom(data.sampleChatRoom)
      : null;
    this.purchasedUsers =
      data?.purchasedUsers?.map((user) => new User(user)) ?? [];
    this.category = data.category ? new Category(data.category) : null;
  }
}
